import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

// Amber banner shown to admins during the 7-day 2FA grace period.
export const TotpGraceBanner = ({ deadline }) => {
  const navigate = useNavigate();
  const daysLeft = Math.max(0, Math.ceil((new Date(deadline) - Date.now()) / 86400000));
  return (
    <div
      data-testid="totp-grace-banner"
      className="mb-4 flex items-center justify-between gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3"
    >
      <div className="flex items-start gap-2.5 min-w-0">
        <ShieldAlert className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
        <p className="text-sm text-amber-800">
          <span className="font-semibold">Activez la double authentification.</span>{" "}
          Obligatoire pour les administrateurs et superviseurs{daysLeft > 0 ? ` d'ici ${daysLeft} jour${daysLeft > 1 ? "s" : ""}` : ""}.
        </p>
      </div>
      <button
        type="button"
        data-testid="totp-grace-banner-cta"
        onClick={() => navigate("/mon-poste")}
        className="shrink-0 inline-flex items-center rounded-lg bg-amber-600 text-white text-xs font-semibold px-3 py-1.5 hover:bg-amber-700 transition-colors"
      >
        Activer
      </button>
    </div>
  );
};
